import { BaseService } from '../baseService'
import config from '@/configurations/config-environment'

const jobOrchestrator = config.apis.jobOrchestrator
export class Importer extends BaseService {
  async setConvertFile(file, token) {
    const authorisation = this.getAuthorizationObject()
    const licenseNumber = authorisation.Licensenumber
    const data = {
      licenseNumber: licenseNumber,
      inputFormatType: file.selectedImportOptions.inputFormatType,
      outputFormatType: 3, // Default format type to Terraindex format
      outputVersion: '1.0',
      conversionFiles: [
        {
          name: file.fileDetails.name,
          contentBase64: file.base64
        }
      ]
    }

    try {
      const response = await fetch(`${jobOrchestrator}/convert`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`
          },
          body: JSON.stringify(data)
        }
      )

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`)
      }

      const responseData = await response.json()
      return responseData.convertJobs[0].orderId
    } catch (error) {
      throw new Error(error)
    }
  }

  async importProject(file, projectFile, token) {
    const authorisation = this.getAuthorizationObject()
    const licenseNumber = authorisation.Licensenumber
    const projectCode = projectFile.newProjectCode ?? projectFile.projectCode

    const data = {
      licenseNumber: licenseNumber,
      orderId: file.conversionInformation.orderId,
      inputFormatType: '3', // Default format type to Terraindex format
      projectFiles: [
        {
          projectCode: projectCode,
          filename: projectFile.filename
        }
      ]
    }

    try {
      const response = await fetch(`${jobOrchestrator}/import`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`
          },
          body: JSON.stringify(data)
        }
      )

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`)
      }

      const responseData = await response.json()
      return responseData.orderId
    } catch (error) {
      throw new Error(error)
    }
  }

  async getJobStatus(orderId, token) {
    try {
      const response = await fetch(`${jobOrchestrator}/status/${orderId}`,
        {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`
          }
        }
      )

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`)
      }

      const responseData = await response.json()
      return responseData
    } catch (error) {
      throw new Error(error)
    }
  }
}
